import type { SVGProps } from 'react';

const SvgYoutubeColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.178 2H7.832C4.205 2 2.044 4.17 2.044 7.81v8.37c0 3.65 2.161 5.82 5.787 5.82h8.338c3.625 0 5.787-2.17 5.787-5.81V7.81C21.966 4.17 19.804 2 16.179 2Z'
      fill='#EFF0F3'
    />
    <path
      d='M8.661 12.001v-1.48c0-1.91 1.345-2.68 2.989-1.73l1.274.74 1.276.74c1.643.95 1.643 2.51 0 3.46l-1.275.74-1.276.74c-1.643.95-2.988.17-2.988-1.73v-1.48Z'
      fill='#F03'
    />
  </svg>
);
export default SvgYoutubeColor;
